import React, { Component } from "react";
import { Form } from "antd";

class FormItem extends Component {
  render() {
    let rules = [];
    if (this.props.pattern) {
      rules.push({
        pattern: /^[A-Za-z0-9\r\n. ,"'´`“”#°ºªáÁéÉíÍóÓúÚüÜñÑ@_=/*+%&()!-:;\\</>[\]]*$/u,
        message: "Contiene caracteres especiales no permitidos",
      });
    } else if (this.props.rfc) {
      rules.push({
        pattern:
          /^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\w{2})([A|a|0-9]{1})$/,
        message: "El RFC no es válido",
      });
    } else if (this.props.number) {
      rules.push({
        pattern: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/,
        message: "Ingresa un número mayor a cero",
      });
    } else if (this.props.numberNegativo) {
      rules.push({
        pattern: /^[0-9.-]*$/,
        message: "Ingresa solo números",
      });
    } else if (this.props.numberCero) {
      rules.push({
        pattern: /^(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i,
        message: "El número no puede ser negativo",
      });
    } else if (this.props.curp) {
      rules.push({
        pattern:
          /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
        message: "La CURP no es válida",
      });
    } else if (this.props.registroPatronal) {
      rules.push({
        pattern:
          /^[A-Z]{3}-\d{6}-\d{2}-\d{1}$/,
        message: "El Registro Patronal no es válido",
      });
    } 
    if (this.props.required) {
      let fieldName = '';
    
      const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
      };

      const cleanFieldName = (field) => {
        const cleanedField = String(field).replace(/\.\d+\./g, ' ').replace(/\d+/g, '').trim();
        return cleanedField.startsWith('.') ? cleanedField.slice(1) : cleanedField;
      };

      if (this.props.label) {
        fieldName = typeof this.props.label === 'string' ? this.props.label : 'Campo';
      } else if (this.props.name) {
        if (Array.isArray(this.props.name)) {
          fieldName = this.props.name.join('.');
        } else {
          fieldName = this.props.name;
        }

        fieldName = cleanFieldName(fieldName);

        if (fieldName.toLowerCase().endsWith('id')) {
          fieldName = fieldName.replace(/id$/i, '').trim();
        } else {
          fieldName = fieldName.replace(/([a-z])([A-Z])/g, '$1 $2');
        }
      } else {
        fieldName = 'Campo';
      }

      fieldName = capitalizeFirstLetter(fieldName);
    
      rules.push({
        required: true,
        message: `Falta el campo:  ${fieldName}`,
      });
    }
    
    
    
    if (this.props.max || this.props.max === 0) {
      rules.push({
        max: this.props.max,
        type: this.props.type,
        message: this.props.type === 'number' ? `El valor máximo es ${this.props.max}`: `Máximo ${this.props.max} caracteres`,
      });
    }
    if(this.props.gt || this.props.gt === 0){
      const gt = this.props.gt
      rules.push({
          validator(_, value) {
            if ( value > gt ) {
              return Promise.resolve();
            }else{
              return Promise.reject(new Error(`Debe ser mayor a ${gt}`));
            }
          },
          message: `Debe ser mayor a ${gt}`
      })
    }
    if (this.props.min || this.props.min === 0) {
      rules.push({
        min: this.props.min,
        type: this.props.type,
        message: this.props.type === 'number' ? `El valor mínimo es ${this.props.min}`: `Mínimo ${this.props.min} caracteres`,
      });
    }
    if (this.props.email) {
      rules.push({
        type: "email",
        message: "El correo no es válido",
      });
    }
    let layout
    if(this.props.specialLayout){
      layout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
      };
    }
    if(this.props.specialLayoutSwitch){
      layout = {
        labelCol: { span: 16 },
        wrapperCol: { span: 8 },
      };
    }
    if(this.props.specialTableLayout){
      layout = {
        labelCol: { span: 0 },
        wrapperCol: { span: 22 },
      };
    }
    if (this.props.rules && this.props.rules.length > 0) {
      rules = [...rules, ...this.props.rules];
    }

    let transformedProperties = {};
    for (var key in this.props) {
      if (
        !(
          key.toString() === "children" ||
          key.toString() === "pattern" ||
          key.toString() === "required" ||
          key.toString() === "max" ||
          key.toString() === "min" ||
          key.toString() === "email" ||
          key.toString() === "margin" ||
          key.toString() === "rfc" ||
          key.toString() === "curp" ||
          key.toString() === "specialLayout" ||
          key.toString() === "type" ||
          key.toString() === "numberCero" ||
          key.toString() === "numberNegativo" ||
          key.toString() === "number" ||
          key.toString() === "registroPatronal" ||
          key.toString() === "rules"
        )
      ) {
        transformedProperties = {
          ...transformedProperties,
          [key]: this.props[key],
        };
      }
    }
    const style = {
      borderWidth: 0,
      border: 0,
      marginBottom: this.props.margin ? "3px" : this.props.marginBottom,
      ...this.props.style,
    };

    // Asterisco pintado a mano cuando no hay `name`
    if (this.props.required && !this.props.name && this.props.label) {
      transformedProperties.label = (
        <>
          <span style={{ color: "#ff4d4f", fontFamily: "SimSun, sans-serif", marginRight: 4 }}>*</span>
          {this.props.label}
        </>
      );
    }

    return (
      <Form.Item
        {...transformedProperties}
        rules={rules}
        style={style}
        {...layout}
      >
        {this.props.children}
      </Form.Item>
    );
  }
}

export default FormItem;
